// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__uDkug","info":"UpdateTermsInfo_info__3T77o"};